// extracted by mini-css-extract-plugin
export default {"city":"City_city__3P2SO","row":"City_row__zO1HH"};